import type { WhatsNextProps } from './index';
import type useClassy from '@core/hooks/useClassy';

import { useProjectStore } from '@core/store';
import RDMD from '@ui/RDMD';
import Textarea from '@ui/Textarea';

interface Props {
  bem: ReturnType<typeof useClassy>;
  description: WhatsNextProps['description'];
  isEditable: WhatsNextProps['isEditable'];
  onChange: WhatsNextProps['onChange'];
}

function Description({ isEditable, bem, onChange, description }: Props) {
  const isRmdx = useProjectStore(s => s.data.features.mdx === 'enabled');

  return isEditable ? (
    <Textarea
      autoGrow="always"
      className={bem('-input', '-description')}
      kind="ghost"
      onChange={onChange}
      placeholder="Tell your users what they should do after they've finished this page"
      resize="none"
      rows={1}
      value={description || ''}
    />
  ) : (
    <RDMD
      className={bem('-description', !description && '-description_empty')}
      renderer={isRmdx ? 'rmdx' : 'rdmd'}
      Tag="div"
    >
      {description}
    </RDMD>
  );
}

export default Description;
